import { IonSkeletonText } from '@ionic/react';
import classes from './style.module.scss';

const WorkoutAssignmentListItemLoader = () => {
  return (
    <div className={classes.workoutAssignmentListItem}>
      <div className={classes.workoutInfoContainer}>
        <IonSkeletonText animated className={classes.image} />
        <div className={classes.workoutInfo}>
          <div className={classes.workoutMetaInfo}>
            <div className={classes.workoutMetaInfoCategoryName}>
              <IonSkeletonText
                animated
                className={classes.workoutName}
                style={{ width: 100 }}
              />
              <IonSkeletonText
                animated
                className={classes.workoutName}
                style={{ width: 150 }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkoutAssignmentListItemLoader;
